import { Divider } from '@mui/material';
import MuiButton from '@mui/material/Button';
import React from 'react';

import { PopupDialogProps } from './PopupDialog.props';
import { Container, Footer, TitleLabel, ContentBox } from './PopupDialog.styles';
import { accentBtnSx, outlinedBtnSx } from '../../../configs/detailPanelStyles';
import { CloseIcon } from '../../atoms/CloseIcon';
import { Modal } from '../../atoms/Modal';
import { TypographyVariantProps } from '../../atoms/Typography';

export const PopupDialog: React.FC<PopupDialogProps> = ({
  title,
  width = '80%',
  maxWidth = '800px',
  children,
  isOpen,
  isClear,
  isEdit,
  onSave,
  onClose,
  onClear,
  actionLabel = 'Save',
  cancelButtonLable = 'Close',
  actionButtonSx,
  isActionDisabled = false,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={(e) => onClose(e)}
      aria-labelledby={`${title}-modal-title`}
      aria-describedby={`${title}-modal-description`}
    >
      <Container style={{ width, maxWidth }}>
        <CloseIcon handleClose={(e, reason) => onClose(reason)} />
        <TitleLabel variant={TypographyVariantProps.H5}>{title}</TitleLabel>
        <Divider />
        <ContentBox>{children}</ContentBox>
        <Divider />
        <Footer direction="row-reverse" spacing={0.75}>
          <MuiButton
            variant="contained"
            size="small"
            onClick={onSave}
            disabled={isActionDisabled}
            sx={{ ...accentBtnSx, ...actionButtonSx }}
          >
            {isEdit ? 'Update' : actionLabel}
          </MuiButton>
          {/* Called with no argument — `onClose` takes a close *reason*, and
              MUI would otherwise hand it a MouseEvent. */}
          <MuiButton variant="outlined" size="small" sx={outlinedBtnSx} onClick={() => onClose()}>
            {cancelButtonLable}
          </MuiButton>
          {isClear && (
            <MuiButton variant="outlined" size="small" sx={outlinedBtnSx} onClick={onClear}>
              Clear
            </MuiButton>
          )}
        </Footer>
      </Container>
    </Modal>
  );
};
